// src/pages/Dashboard.jsx
import React, { useState, useEffect } from "react";
import RolMenu from "../components/RolMenu";
import PublicacionForm from "../components/PublicacionesFrom";
import PublicacionesList from "../components/PublicacionesList";
import NoticiasCarousel from "../components/NoticiasCarousel";
import DocumentosCorporativos from "../components/DocumentosCorporativos";
import EditUser from "../components/EditUser";
import { useActiveModule } from "../components/ActiveModuleContext";
import Tramites from "../components/Tramites";
import NuevoUsuario from "../components/NuevoUsuario";
import BuscarEmpleado from "../components/BuscarEmpleado";
import ActualizarEmpleadoAdmin from "../components/ActualizarEmpleadoAdmin";
import GestionDesprendibles from "../components/GestionDesprendibles";

export default function Dashboard() {
  const user = JSON.parse(localStorage.getItem("user"));
  const [empleadoActivo, setEmpleadoActivo] = useState(null);

  const { activeModule, setActiveModule } = useActiveModule();

  // ----------------------------------------------------------------------
  // Asegurar que el módulo por defecto sea "Noticias" si no hay ninguno.
  // Esto preserva el comportamiento anterior: al cargar el dashboard,
  // se muestra por defecto el módulo de noticias.
  // ----------------------------------------------------------------------
  useEffect(() => {
    if (!activeModule) {
      setActiveModule("Noticias");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // se ejecuta solo al montar para evitar sobrescribir selecciones posteriores

  // ----------------------------------------------------------------------
  // Render dinámico de módulos (igual que antes)
  // ----------------------------------------------------------------------
  const renderModule = () => {
    switch (activeModule) {
      case "Publicaciones":
        return <PublicacionForm />;

      case "DocumentosCorporativos":
        return <DocumentosCorporativos user={user} />;

      case "EditarPerfil":
        return <EditUser key={activeModule} />;

      case "Tramites":
        return <Tramites user={user} />;

      case "NuevoUsuario":
        return <NuevoUsuario user={user} onSelectModule={setActiveModule} />;

      case "BuscarEmpleado":
        return (
          <BuscarEmpleado
            onEditar={(empleadoSeleccionado) => {
              setEmpleadoActivo(empleadoSeleccionado);
              setActiveModule("ActualizarEmpleado");
            }}
          />
        );

      case "ActualizarEmpleado":
        return (
          <ActualizarEmpleadoAdmin
            empleado={empleadoActivo}
            onVolver={() => setActiveModule("BuscarEmpleado")}
          />
        );

      case "Noticias":
      default:
        // Mantengo PublicacionesList como módulo principal de noticias (tu implementación previa)
        return <PublicacionesList />;


       case "GestionDesprendibles":
      return <GestionDesprendibles user={user} />;
    }

   
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Carrusel superior: sigue independiente y se encarga de su propio fetch */}
      <div className="bg-white shadow-md rounded-lg p-4">
        <NoticiasCarousel />
      </div>

      {/* Cuerpo */}
      <div className="flex-1 grid grid-cols-4 gap-6 p-6">
        <div className="col-span-1 shadow-md rounded-lg p-4 bg-white">
          <RolMenu
            user={user}
            currentModule={activeModule}
            onSelectModule={setActiveModule}
          />
        </div>

        <div className="col-span-3 bg-white shadow-md rounded-lg p-6">
          {renderModule()}
        </div>
      </div>
    </div>
  );
}
